var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3.71 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1138",
    "data-name": "Rectangle 1138",
    width: 32,
    height: 32,
    transform: "translate(-3.71 -3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M20.006,3.574V5.135H9.783A2.358,2.358,0,0,0,7.425,7.5V20.864H5.857A1.609,1.609,0,0,1,4.744,20.4,1.588,1.588,0,0,1,4.29,19.29V3.574A1.554,1.554,0,0,1,5.857,2H18.431a1.567,1.567,0,0,1,1.574,1.574Z",
    transform: "translate(0 0)",
    fill: "#09c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4559",
    "data-name": "Path 4559",
    d: "M24.781,9.314a1.581,1.581,0,0,0-1.107-.454h-11A1.554,1.554,0,0,0,11.1,10.434V24.576a1.554,1.554,0,0,0,1.6,1.567h11a1.581,1.581,0,0,0,1.079-.454,1.609,1.609,0,0,0,.461-1.107V10.434A1.609,1.609,0,0,0,24.781,9.314ZM22.1,22.211h-7.83V20.643h7.865Zm0-3.932h-7.83V16.711h7.865Zm0-3.932h-7.83V12.779h7.865Z",
    transform: "translate(-2.128 -2.144)",
    fill: "#09c",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachReports);
export default __webpack_public_path__ + "static/media/attach-reports.e8160e973a71c29b80d3a2ba21813557.svg";
export { ForwardRef as ReactComponent };